import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { Button, IconButton, Typography, Grid } from '@mui/material'
import { ReactComponent as CloseButtonIcon } from '../../assets/CloseXIcon.svg'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveIcon from '@mui/icons-material/Remove';
import { theme } from '../../theme/theme';
import moment from 'moment'

const SetupErrorDetailsModal = (props) => {
    const setupErrors = props.setupErrors
    if (!setupErrors) {
        return null
    }

    // There are technically three different configuration results, but
    // roll them up into one
    let resultAllConfiguration = 'Pass'
    if (setupErrors.resultConfVPN !== 'Pass') {
        resultAllConfiguration = 'Fail'
    }
    if (setupErrors.resultConfSoftware !== 'Pass') {
        resultAllConfiguration = 'Fail'
    }
    if (setupErrors.resultConfMQTT !== 'Pass') {
        resultAllConfiguration = 'Fail'
    }

    const createResultRow = (title, result) => {
        return (
            <Grid container sx={{
                color: theme.palette.sidebarContent.labelText,
                justifyContent: 'space-between',
            }}>
                <Grid item><Typography>{title}</Typography></Grid>
                <Grid item>
                    {result === 'Pass' && <CheckCircleIcon color="success" />}
                    {result === 'Fail' && <ErrorIcon color="error" />}
                    {result === 'Skip' && <RemoveIcon color="#ffffff" />}
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                PaperProps={{
                    style: {
                        backgroundColor: "#0A1826",
                        width: '700px',
                        minWidth: '700px',
                    }
                }}>
                <DialogTitle sx={{
                    color: theme.palette.primary.contrastText,
                    backgroundColor: '#2C5877',
                    fontWeight: 700,
                    fontFamily: 'Open Sans',
                    fontSize: '18px',
                    width: '100%',
                    letterSpacing: '0px'
                }}
                    style={{
                        display: 'flex',
                        padding: '5px 15px',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                    Internet Status Details
                    <IconButton edge="end" onClick={props.onClose}><CloseButtonIcon /></IconButton>
                </DialogTitle>
                <DialogContent style={{padding: '20px 85px'}}>
                    <Grid item sx={{fontWeight: 700, color: theme.palette.primary.contrastText, mb: 1}}>Connection</Grid>
                    {createResultRow(`Ethernet cable installed?`, setupErrors.resultConnCable)}
                    {createResultRow(`Obtained IP for MAC ${setupErrors.mac}? IP: ${setupErrors.ip}`, setupErrors.resultConnAddress)}
                    <br/>
                    <Grid item sx={{fontWeight: 700, color: theme.palette.primary.contrastText, mb: 1}}>DNS</Grid>
                    {createResultRow(`Configuration installed?`, resultAllConfiguration)}
                    {createResultRow(setupErrors.resultConfVPN === 'Pass' ? `Resolved ${setupErrors.hostnameVPN}` : `No VPN hostname found`, setupErrors.resultResolveVPN)}
                    {createResultRow(setupErrors.resultConfSoftware === 'Pass' ? `Resolved ${setupErrors.hostnameSoftware}` : `No software update hostname found`, setupErrors.resultResolveSoftware)}
                    {createResultRow(setupErrors.resultConfMQTT === 'Pass' ? `Resolved ${setupErrors.hostnameMQTT}` : `No MQTT hostname found`, setupErrors.resultResolveMQTT)}
                    <br/>
                    <Grid item sx={{fontWeight: 700, color: theme.palette.primary.contrastText, mb: 1}}>Ports</Grid>
                    {createResultRow(`TCP port 22 open?`, setupErrors.resultPortSoftware)}
                    {createResultRow(`UDP port 1194 open?`, setupErrors.resultPortVPN)}
                    {createResultRow(`TCP port 8883 open?`, setupErrors.resultPortMQTT)}
                    <br/>
                    <Grid item sx={{fontWeight: 700, color: theme.palette.primary.contrastText, mb: 1}}>Communication</Grid>
                    {createResultRow(`VPN`, setupErrors.resultCommVPN)}
                    {createResultRow(`Software Updates`, setupErrors.resultCommSoftware)}
                    {createResultRow(`MQTT`, setupErrors.resultCommMQTT)}
                </DialogContent>
                <DialogActions style={{padding: '0 90px 30px 90px'}}>
                    <Typography sx={{color: theme.palette.primary.contrastText, mr:1}}>
                        Last Run: {setupErrors.timestamp ? moment(setupErrors.timestamp).format('MM/DD/YY hh:mm:ss a'): '-- --'}
                    </Typography>
                    <span style={{ flexGrow: 1 }}/>
                    <Button onClick={props.onClose} sx={{
                        backgroundColor: '#ADADAD', 
                        color: '#626262', 
                        height:'35px',
                        width:'95px',
                        fontWeight: '600',
                        textTransform:'none',
                        fontFamily: 'Open Sans',
                        fontSize: '15px',                             
                        letterSpacing: '0.53px'}}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default SetupErrorDetailsModal
